import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import Typography from "../../primitives/Typography/Typography";
import css from "./Page.module.css";

const PageRoot = React.forwardRef(
  ({ as: Component = "div", className, children, ...rest }, ref) => (
    <Component ref={ref} className={clsx(css.root, className)} {...rest}>
      {children}
    </Component>
  ),
);

PageRoot.displayName = "PageRoot";

PageRoot.propTypes = {
  as: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.node,
};

const PageHead = React.forwardRef(
  (
    {
      title,
      back,
      description,
      actions,
      stackActions = false,
      className,
      children,
      ...rest
    },
    ref,
  ) => (
    <header
      ref={ref}
      className={clsx(css.head, stackActions && css.stacked, className)}
      {...rest}
    >
      {back && <div className={css.back}>{back}</div>}
      <div className={css.row}>
        <div className={css.heading}>
          <Typography variant="headline-md" as="h1">
            {title}
          </Typography>
          {description && <div className={css.description}>{description}</div>}
        </div>
        {actions && <div className={css.actions}>{actions}</div>}
      </div>
      {children}
    </header>
  ),
);

PageHead.displayName = "PageHead";

PageHead.propTypes = {
  title: PropTypes.node.isRequired,
  back: PropTypes.node,
  description: PropTypes.node,
  actions: PropTypes.node,
  stackActions: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

const PageSection = React.forwardRef(
  ({ as: Component = "div", className, children, ...rest }, ref) => (
    <Component ref={ref} className={clsx(css.section, className)} {...rest}>
      {children}
    </Component>
  ),
);

PageSection.displayName = "PageSection";

PageSection.propTypes = {
  as: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.node,
};

const Page = {
  Root: PageRoot,
  Head: PageHead,
  Section: PageSection,
};

export default Page;
